module.exports = __webpack_public_path__ + "c2db37b8df2df80dd88921effaf054d4.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/loading-transparent.svg
// module id = 479
// module chunks = 74